import React from 'react'
import '../App.css'

import fb from '../imagines/icons8-facebook.svg'
import insta from '../imagines/icons8-instagram.svg'
import yelp from '../imagines/icons8-yelp.svg'

const footer = () => {
  return (
    <>
      <div className='footer'>
        <div className='footer-container'>
          <div className='footer-locations'>
            <h3>LOCATIONS</h3>
            <div className='footer-location'>
              <p className='footer-location-name'>iNails and Spa 1</p>
              <p className='footer-location-address'>6 N 4th Ave #3, Chula Vista, CA 91910</p>
              <a href='tel:+16198822199' className='footer-location-phone'>(619) 882-2199</a>
            </div>
            <div className='footer-location'>
              <p className='footer-location-name'>iNails and Spa 2</p>
              <p className='footer-location-address'>3041 Bonita Rd, Chula Vista, CA 91910</p>
              <a href='tel:+16198822199' className='footer-location-phone'>(619) 422-2141</a>
            </div>
          </div>
          <div className='footer-operating-hours'>
            <h3>BUSINESS HOURS</h3>
            <ul className="footer-hours">
              <li><strong>Monday:</strong> 9:00 AM – 7:00 PM</li>
              <li><strong>Tuesday:</strong> 9:00 AM – 7:00 PM</li>
              <li><strong>Wednesday:</strong> 9:00 AM – 7:00 PM</li>
              <li><strong>Thursday:</strong> 9:00 AM – 7:00 PM</li>
              <li><strong>Friday:</strong> 9:00 AM – 7:00 PM</li>
              <li><strong>Saturday:</strong> 9:00 AM – 7:00 PM</li>
              <li><strong>Sunday:</strong> 10:00 AM – 6:00 PM</li>
            </ul>
          </div>
          <div className='footer-follow'>
            <h3>FOLLOW US</h3>
            <div className='footer-socials'>
              <a href='https://www.facebook.com/profile.php?id=61552840867110' target='_blank' rel="noopener noreferrer" className='footer-social-link'><img src={fb} alt='Facebook logo'/></a>
              <a href='https://www.instagram.com/inailsnspasd' target='_blank' rel="noopener noreferrer" className='footer-social-link'><img src={insta} alt='Instagram logo'/></a>
              <a href='https://www.yelp.com/biz/inails-and-spa-chula-vista-4?osq=iNails+And+Spa' target='_blank' rel="noopener noreferrer" className='footer-social-link'><img src={yelp} alt='Yelp Logo'/></a>
            </div>
          </div>
        </div>
        <hr/>
        <div className='footer-copyright'>
          <p>© {new Date().getFullYear()} iNails and Spa. All rights reserved.</p>
          <p>Designed by <a href='https://hpham.dev/' target='_blank' rel="noopener noreferrer" className='footer-design'><u>Hpham.dev</u></a></p>
        </div>
      </div>
    </>
  )
}

export default footer